(function () {
  'use strict';

  /* The sale strip scrolls away; once it does, pin the logo navbar to the top.
     position:sticky can't do this because the navbar lives in its own short
     section, so it's toggled to fixed on scroll with a spacer to avoid a jump. */
  function initFiveToeSocksStickyNav() {
    if (!document.body.classList.contains('frido-five-toe-socks-page')) return;

    var nav = document.querySelector('.ft-nav');
    var strip = document.querySelector('.ft-topbar');
    if (!nav || !strip || !nav.parentNode) return;

    var spacer = document.createElement('div');
    spacer.setAttribute('data-ft-nav-spacer', '');
    spacer.style.height = '0px';
    nav.parentNode.insertBefore(spacer, nav.nextSibling);

    var stripH = strip.offsetHeight;
    var stuck = false;

    function onScroll() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var shouldStick = y >= stripH;
      if (shouldStick === stuck) return;
      stuck = shouldStick;
      if (stuck) {
        // Measure while the navbar is still in flow so the spacer matches its
        // real height (the logo image may have loaded after init).
        spacer.style.height = nav.offsetHeight + 'px';
        nav.classList.add('ft-nav--stuck');
      } else {
        nav.classList.remove('ft-nav--stuck');
        spacer.style.height = '0px';
      }
    }

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      stripH = strip.offsetHeight;
      if (stuck) spacer.style.height = nav.offsetHeight + 'px';
      onScroll();
    });
  }

  function initFiveToeSocksBuyGalleryLayout() {
    if (!document.body.classList.contains('frido-five-toe-socks-page')) return;

    var page = document.getElementById('PageContainer') || document.querySelector('main')  /* the layout this page was written against gave <main> the id PageContainer; this theme's main is #MainContent, so fall back to the element rather than the id */;
    if (!page) return;

    var galleryHost = page.querySelector('[data-ft-buy-gallery]');
    if (!galleryHost) return;

    var buyCard = page.querySelector('[data-frido-five-toe-socks-fold-item="buy"] .ft-buy-card');
    if (buyCard) buyCard.classList.add('ft-buy-card--has-gallery');

    if (galleryHost.getAttribute('data-ft-buy-gallery-mounted') === 'true') return;

    var gallerySection = page.querySelector(
      '.shopify-section:has([data-frido-five-toe-socks-fold-item="gallery"])'
    );
    if (!gallerySection) {
      var galleryEl = page.querySelector('[data-frido-five-toe-socks-fold-item="gallery"]');
      gallerySection = galleryEl ? galleryEl.closest('.shopify-section') : null;
    }

    if (!gallerySection || !buyCard) return;

    galleryHost.setAttribute('data-ft-buy-gallery-mounted', 'true');
    galleryHost.appendChild(gallerySection);
  }

  function dispatchGalleryColorChange(colorValue) {
    if (!colorValue) return;
    document.dispatchEvent(
      new CustomEvent('frido:pdp-gallery-color-change', {
        detail: { colorValue: colorValue },
      })
    );
  }

  function getGalleryColorFromButton(btn) {
    if (!btn) return '';
    return btn.getAttribute('data-gallery-color') || btn.getAttribute('data-color') || '';
  }

  function getGalleryColorForVariant(variant) {
    if (!variant) return '';
    return variant.galleryColor || variant.color || '';
  }

  var PINCODE_STORAGE_KEY = 'frido-pdp-delivery-pincode';

  function isValidPincode(value) {
    return /^\d{6}$/.test(String(value || '').trim());
  }

  function readStoredPincode() {
    try {
      return localStorage.getItem(PINCODE_STORAGE_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function storePincode(pincode) {
    try {
      localStorage.setItem(PINCODE_STORAGE_KEY, pincode);
    } catch (e) {
      /* ignore */
    }
  }

  function formatPincodeError(apiError) {
    var hint = 'Please enter a correct pincode.';
    var detail = apiError && String(apiError).trim();
    if (detail) return detail + ' ' + hint;
    return hint;
  }

  function initDeliveryEstimate(productData) {
    var root = document.querySelector('[data-ft-delivery]');
    if (!root) return;

    var formView = root.querySelector('[data-ft-delivery-form]');
    var resultView = root.querySelector('[data-ft-delivery-result]');
    var input = root.querySelector('[data-ft-pincode-input]');
    var checkBtn = root.querySelector('[data-ft-pincode-check]');
    var editBtn = root.querySelector('[data-ft-pincode-edit]');
    var errorEl = root.querySelector('[data-ft-pincode-error]');
    var messageEl = root.querySelector('[data-ft-delivery-message]');
    var apiUrl =
      root.getAttribute('data-delivery-api') ||
      (productData && productData.deliveryApiUrl) ||
      'https://rapi.myfrido.com/api/v2/expected-delivery-date';
    var store =
      root.getAttribute('data-delivery-store') ||
      (productData && productData.deliveryStore) ||
      'myfrido';
    var isChecking = false;

    function showFormView() {
      root.classList.remove('has-delivery-result');
      if (formView) formView.hidden = false;
      if (resultView) resultView.hidden = true;
      if (errorEl) errorEl.hidden = true;
    }

    function showResultView(message) {
      if (messageEl) messageEl.textContent = message || '';
      root.classList.add('has-delivery-result');
      if (formView) formView.hidden = true;
      if (resultView) resultView.hidden = false;
      if (errorEl) errorEl.hidden = true;
    }

    function showError(message) {
      showFormView();
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
      if (input) input.setAttribute('aria-invalid', 'true');
    }

    function clearError() {
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.hidden = true;
      }
      if (input) input.removeAttribute('aria-invalid');
    }

    function setLoading(loading) {
      if (checkBtn) {
        checkBtn.disabled = loading;
        checkBtn.textContent = loading ? 'CHECKING...' : 'CHECK';
      }
      if (input) input.disabled = loading;
    }

    function checkPincode(silent) {
      if (isChecking) return;
      var pincode = input ? input.value.trim() : '';
      if (!isValidPincode(pincode)) {
        showError(formatPincodeError('Pincode must be exactly 6 digits'));
        return;
      }

      clearError();
      isChecking = true;
      setLoading(true);

      fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          pincode: pincode,
          store: store,
        }),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, data: data };
          });
        })
        .then(function (result) {
          var data = result.data || {};
          if (data.success && data.message) {
            storePincode(pincode);
            showResultView(data.message);
            return;
          }
          if (silent) {
            showFormView();
          } else {
            showError(formatPincodeError(data.error));
          }
        })
        .catch(function () {
          if (silent) {
            showFormView();
          } else {
            showError(formatPincodeError('Unable to check delivery right now'));
          }
        })
        .finally(function () {
          isChecking = false;
          setLoading(false);
        });
    }

    if (checkBtn) {
      checkBtn.addEventListener('click', function () {
        checkPincode(false);
      });
    }

    if (input) {
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          checkPincode(false);
        }
      });
      input.addEventListener('input', function () {
        var digits = input.value.replace(/\D/g, '').slice(0, 6);
        if (input.value !== digits) input.value = digits;
        clearError();
      });
    }

    if (editBtn) {
      editBtn.addEventListener('click', function () {
        showFormView();
        if (input) {
          input.focus();
          input.select();
        }
      });
    }

    var saved = readStoredPincode();
    if (saved && input) {
      input.value = saved;
      checkPincode(true);
    }
  }

  function initFiveToeSocksPage() {
    var dataNode = document.getElementById('ftProductData');
    if (!dataNode) return;

    var productData = {};
    try {
      productData = JSON.parse(dataNode.textContent);
    } catch (e) {
      return;
    }

    var selectedPack = '';
    var selectedVariantId = String(productData.defaultVariantId || '');
    var selectedStyle = String(productData.defaultStyle || 'classic');
    var styleColorMemory = {};
    var packQtyMap = productData.packQty || { 1: 1, 2: 2, 4: 4 };
    var packDiscountCents = productData.packDiscountCents || { 2: 19900, 4: 59700 };
    var modalPairSelections = [];

    function formatMoney(cents) {
      var amount = Number(cents || 0) / 100;
      var formatted = amount.toLocaleString('en-IN', {
        minimumFractionDigits: 0,
        maximumFractionDigits: amount % 1 === 0 ? 0 : 2,
      });
      return '\u20B9' + formatted;
    }

    function qs(sel) {
      return document.querySelector(sel);
    }
    function qsa(sel) {
      return Array.prototype.slice.call(document.querySelectorAll(sel));
    }

    function findVariantForSelection(style, color) {
      var styleKey = style || selectedStyle;
      var colorName = color || getActiveColorName();
      var variants = productData.variants || [];
      var i;
      for (i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.style === styleKey && v.color === colorName) return v;
      }
      return null;
    }

    function getActiveColorName() {
      var activeBtn = qs('[data-ft-colors-scroll] .ft-color-btn.active');
      if (!activeBtn) activeBtn = qs('.ft-color-btn.active');
      return activeBtn ? activeBtn.getAttribute('data-color') : '';
    }

    function updateBuyTitle(style) {
      var el = qs('[data-ft-buy-title]');
      if (!el) return;
      var titles = productData.titles || {};
      var t = titles[style] || productData.title;
      if (t) el.textContent = t;
    }

    function applyResolvedVariant(variant, colorBtn) {
      if (!variant) return;
      selectedVariantId = String(variant.id);
      updateMainPriceDisplay(variant);
      updatePackPrices(variant.price || productData.unitPriceCents);
      updateBuyTitle(variant.style || selectedStyle);
      if (colorBtn) {
        activateColorButton(colorBtn);
        updateColorLabel(colorBtn);
        dispatchGalleryColorChange(
          getGalleryColorFromButton(colorBtn) || getGalleryColorForVariant(variant)
        );
      }
    }
    function getSelectedVariant() {
      var i;
      var variants = productData.variants || [];
      for (i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(selectedVariantId)) return variants[i];
      }
      return variants[0] || null;
    }

    function getUniqueColors(style) {
      var styleKey = style || selectedStyle;
      var seen = {};
      var list = [];
      (productData.variants || []).forEach(function (v) {
        if (v.style !== styleKey || !v.color || seen[v.color]) return;
        seen[v.color] = true;
        list.push(v);
      });
      return list;
    }

    function variantIdForColor(color, style) {
      var variant = findVariantForSelection(style, color);
      return variant ? variant.id : selectedVariantId;
    }

    function getDefaultColor() {
      var variant = getSelectedVariant();
      return variant && variant.color ? variant.color : null;
    }

    function getPackConfig() {
      var packs = productData.packs || {};
      return packs[selectedPack] || packs['1'] || { qty: 1, discountAmount: null, discountCode: null };
    }

    function buildCheckoutUrl(variantIds) {
      var counts = {};
      var order = [];
      variantIds.forEach(function (id) {
        var key = String(id);
        if (counts[key]) counts[key]++;
        else {
          counts[key] = 1;
          order.push(key);
        }
      });
      var qty = variantIds.length;
      var name =
        (productData.title || 'Frido Five Toe Socks') +
        ' - ' +
        qty +
        (qty > 1 ? ' Pairs' : ' Pair');
      var parts = order.map(function (id) {
        return id + ':' + counts[id];
      });
      var pack = getPackConfig();
      var query = ['rfname=' + encodeURIComponent(name), 'tt-cart-mod=true'];
      if (pack.discountAmount) {
        query.push('disam=__' + encodeURIComponent(pack.discountAmount));
      }
      if (pack.discountCode) {
        query.push('discount=' + encodeURIComponent(pack.discountCode));
      }
      return (productData.cartUrl || '/cart') + '/' + parts.join(',') + '?' + query.join('&');
    }

    function setButtonLoading(btn, loading) {
      if (!btn) return;
      var textEl = btn.querySelector('.btnText');
      var spinEl = btn.querySelector('.spin');
      btn.classList.toggle('loading', !!loading);
      btn.classList.toggle('is-loading', !!loading);
      btn.disabled = !!loading;
      if (textEl) {
        textEl.hidden = false;
        textEl.setAttribute('aria-hidden', loading ? 'true' : 'false');
      }
      if (spinEl) spinEl.hidden = !loading;
      if (loading) btn.setAttribute('aria-busy', 'true');
      else btn.removeAttribute('aria-busy');
    }

    function checkoutWithVariants(variantIds, btn) {
      var cartUrl = buildCheckoutUrl(variantIds);
      var pack = getPackConfig();
      var expectedCount = variantIds.length;
      var fallbackUrl =
        cartUrl.indexOf('http') === 0 ? cartUrl : 'https://myfrido.com' + cartUrl;

      setButtonLoading(btn, true);

      var isColorSheetBtn = !!(btn && btn.closest('#ftColorSheet'));

      if (
        window.FridoPdpGokwikCheckout &&
        window.FridoPdpGokwikCheckout.shouldUseGokwik &&
        window.FridoPdpGokwikCheckout.shouldUseGokwik() &&
        window.FridoPdpGokwikCheckout.prepareCartAndCheckout
      ) {
        window.FridoPdpGokwikCheckout.prepareCartAndCheckout({
          cartUrl: cartUrl,
          uiButton: isColorSheetBtn ? null : btn,
          expectedCount: expectedCount,
          discountCode: pack.discountCode || '',
          fallbackUrl: fallbackUrl,
          onComplete: function () {
            setButtonLoading(btn, false);
            if (isColorSheetBtn) closeColorSheet();
          },
          onError: function () {
            setButtonLoading(btn, false);
          },
        });
        return;
      }

      window.location.href = fallbackUrl;
    }

    function getAllUniqueColors() {
      var seen = {};
      var list = [];

      // Follow the rendered swatch order so the pair modal always matches the
      // main color scroll, whose order is set explicitly in Liquid.
      qsa('[data-ft-colors-scroll] .ft-color-btn').forEach(function (btn) {
        var style = btn.getAttribute('data-style');
        var color = btn.getAttribute('data-color');
        if (!style || !color) return;
        var key = style + '|' + color;
        if (seen[key]) return;
        var variant = findVariantForSelection(style, color);
        if (!variant) return;
        seen[key] = true;
        list.push(variant);
      });
      if (list.length) return list;

      // Fallback if the buy-box scroll isn't in the DOM.
      var order = ['solid', 'classic', 'patterned'];
      order.forEach(function (style) {
        (productData.variants || []).forEach(function (v) {
          if (v.style !== style || !v.color) return;
          var key = style + '|' + v.color;
          if (seen[key]) return;
          seen[key] = true;
          list.push(v);
        });
      });
      return list;
    }

    function getDefaultPairSelection() {
      var variant = getSelectedVariant();
      if (variant && variant.style && variant.color) {
        return { style: variant.style, color: variant.color };
      }
      return {
        style: selectedStyle,
        color: getActiveColorName() || getDefaultColorForStyle(selectedStyle),
      };
    }

    function getDefaultColorForStyle(style) {
      if (styleColorMemory[style]) return styleColorMemory[style];
      var colors = getUniqueColors(style);
      if (colors.length) return colors[0].color;
      var variant = getSelectedVariant();
      return variant && variant.color ? variant.color : '';
    }

    function pairSelectionMatches(a, b) {
      return a && b && a.style === b.style && a.color === b.color;
    }

    function refreshModalPairRows(qty) {
      var list = qs('[data-ft-color-sheet-pairs]');
      if (!list) return;

      list.innerHTML = '';
      var i;
      for (i = 0; i < qty; i++) {
        (function (index) {
          var rowTitle = qty > 1 ? 'Pair ' + (index + 1) : 'Choose your color';
          var row = document.createElement('div');
          row.className = 'ft-color-sheet-row';
          row.innerHTML =
            '<div class="ft-color-picker__head"><span class="ft-color-picker__title">' +
            rowTitle +
            '</span></div>' +
            '<p class="ft-color-value" data-ft-pair-color-label="' +
            index +
            '"></p>' +
            '<div class="ft-colors-scroll-wrap ft-colors-scroll-wrap--modal">' +
            '<div class="ft-colors ft-colors--scroll ft-colors--modal" data-ft-pair-swatches="' +
            index +
            '" role="list"></div></div>';
          list.appendChild(row);

          var swWrap = row.querySelector('[data-ft-pair-swatches]');
          var label = row.querySelector('[data-ft-pair-color-label]');

          function pick(selection) {
            modalPairSelections[index] = {
              style: selection.style,
              color: selection.color,
            };
            if (label) label.textContent = selection.color;
            renderModalSwatches(swWrap, modalPairSelections[index], pick);
            updateColorScrollPeek();
          }

          pick(modalPairSelections[index] || getDefaultPairSelection());
        })(i);
      }
    }

    function renderModalSwatches(container, selectedSelection, onPick) {
      container.innerHTML = '';
      getAllUniqueColors().forEach(function (v) {
        var isActive = pairSelectionMatches(selectedSelection, {
          style: v.style,
          color: v.color,
        });
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ft-color-btn' + (isActive ? ' active' : '');
        btn.setAttribute('data-color', v.color);
        btn.setAttribute('data-style', v.style);
        btn.setAttribute('aria-label', v.color);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');

        var swatch = document.createElement('span');
        swatch.className = 'ft-color-swatch';
        if (v.swatchImage || v.featuredImage) {
          var img = document.createElement('img');
          img.src = v.swatchImage || v.featuredImage;
          img.alt = '';
          img.width = 56;
          img.height = 56;
          img.loading = 'lazy';
          img.decoding = 'async';
          swatch.appendChild(img);
        }
        btn.appendChild(swatch);

        btn.addEventListener('click', function () {
          onPick({ style: v.style, color: v.color });
        });
        container.appendChild(btn);
      });
      scrollActiveColorInScroll(container, 'smooth');
    }

    function openColorSheet(qty) {
      var defaultSelection = getDefaultPairSelection();
      modalPairSelections = [];
      var i;
      for (i = 0; i < qty; i++) {
        modalPairSelections.push({
          style: defaultSelection.style,
          color: defaultSelection.color,
        });
      }

      refreshModalPairRows(qty);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          scrollAllModalColorRows('auto');
        });
      });
      updateColorScrollPeek();

      var checkoutBtn = qs('[data-ft-color-checkout]');
      if (checkoutBtn) setButtonLoading(checkoutBtn, false);

      closeSheet();

      var overlay = qs('#ftColorOverlay');
      var sheet = qs('#ftColorSheet');
      if (overlay) overlay.classList.add('show');
      if (sheet) {
        sheet.classList.add('show');
        sheet.setAttribute('aria-hidden', 'false');
      }
      document.body.style.overflow = 'hidden';
    }

    function closeColorSheet() {
      var overlay = qs('#ftColorOverlay');
      var sheet = qs('#ftColorSheet');
      if (overlay) overlay.classList.remove('show');
      if (sheet) {
        sheet.classList.remove('show');
        sheet.setAttribute('aria-hidden', 'true');
      }
      var packSheet = qs('#ftSheet');
      if (!packSheet || !packSheet.classList.contains('show')) {
        document.body.style.overflow = '';
      }
    }

    function confirmColorCheckout(btn) {
      var ids = modalPairSelections.map(function (sel) {
        var variant = findVariantForSelection(sel.style, sel.color);
        return variant ? variant.id : selectedVariantId;
      });
      checkoutWithVariants(ids, btn);
    }

    function updateMainPriceDisplay(variant) {
      if (!variant) return;
      var priceEl = qs('#ftMainPrice');
      var mrpEl = qs('#ftMainMrp');
      var saveEl = qs('#ftMainSave');
      var saleCents = Number(variant.price || 0);
      var mrpCents = Number(variant.compareAtPrice || 0);
      if (priceEl) priceEl.textContent = formatMoney(saleCents);
      if (mrpEl) {
        if (mrpCents > saleCents && mrpCents > 0) {
          mrpEl.textContent = formatMoney(mrpCents);
          mrpEl.hidden = false;
        } else {
          mrpEl.hidden = true;
        }
      }
      if (saveEl) {
        if (mrpCents > saleCents && mrpCents > 0) {
          var pct = Math.round(((mrpCents - saleCents) * 100) / mrpCents);
          saveEl.textContent = 'Save ' + pct + '%';
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }
    }

    function updatePackPrices(unitPriceCents) {
      var unit = Number(unitPriceCents || 0);
      var pack2Discount = Number(packDiscountCents['2'] || 19900);
      var pack4Discount = Number(packDiscountCents['4'] || 59700);
      var pack1Price = unit;
      var pack2Price = unit * 2 - pack2Discount;
      var pack4Price = unit * 4 - pack4Discount;
      var perPair2 = Math.round(pack2Price / 2);
      var perPair4 = Math.round(pack4Price / 4);

      qsa('.ft-pack-btn').forEach(function (btn) {
        var pack = btn.getAttribute('data-pack');
        var priceText = formatMoney(unit);
        var metaEl = btn.querySelector('.ft-pack-meta');
        if (pack === '1') {
          priceText = formatMoney(pack1Price);
        } else if (pack === '2') {
          priceText = formatMoney(pack2Price);
          if (metaEl) metaEl.textContent = formatMoney(perPair2) + ' / pair';
        } else if (pack === '4') {
          priceText = formatMoney(pack4Price);
          if (metaEl) metaEl.textContent = formatMoney(perPair4) + ' / pair';
        }
        btn.setAttribute('data-price', priceText);
        var priceEl = btn.querySelector('.ft-pack-price');
        if (priceEl) priceEl.textContent = priceText;
      });

      if (selectedPack) {
        var activePackBtn = qs('.ft-pack-btn[data-pack="' + selectedPack + '"]');
        if (activePackBtn) {
          setPack(
            selectedPack,
            activePackBtn.getAttribute('data-price'),
            activePackBtn.getAttribute('data-label')
          );
        }
      }
    }

    function setPack(pack, price, label) {
      selectedPack = pack;
      qsa('.ft-pack-btn').forEach(function (btn) {
        btn.classList.toggle('active', btn.getAttribute('data-pack') === pack);
      });
      if (qs('#ftStickyPrice')) qs('#ftStickyPrice').textContent = price;
      if (qs('#ftStickyPack')) qs('#ftStickyPack').textContent = label;
      var packValueEl = qs('[data-ft-pack-value]');
      if (packValueEl && label) packValueEl.textContent = label;
    }

    function updateColorLabel(btn) {
      var valueEl = qs('[data-ft-color-value]');
      if (!valueEl || !btn) return;
      var colorName = btn.getAttribute('data-color') || btn.getAttribute('aria-label') || '';
      valueEl.textContent = colorName;
    }

    function scrollActiveColorInScroll(scrollEl, behavior, btn) {
      if (!scrollEl) return;
      var targetBtn = btn || scrollEl.querySelector('.ft-color-btn.active');
      if (!targetBtn) return;

      var btnRect = targetBtn.getBoundingClientRect();
      var containerRect = scrollEl.getBoundingClientRect();
      var delta =
        btnRect.left +
        btnRect.width / 2 -
        (containerRect.left + containerRect.width / 2);
      var nextLeft = Math.max(
        0,
        Math.min(scrollEl.scrollLeft + delta, scrollEl.scrollWidth - scrollEl.clientWidth)
      );

      if (scrollEl.scrollTo) {
        scrollEl.scrollTo({
          left: nextLeft,
          behavior: behavior || 'smooth',
        });
      } else {
        scrollEl.scrollLeft = nextLeft;
      }
    }

    function scrollAllModalColorRows(behavior) {
      qsa('[data-ft-pair-swatches]').forEach(function (scrollEl) {
        scrollActiveColorInScroll(scrollEl, behavior);
      });
      updateColorScrollPeek();
    }

    function scrollColorIntoView(btn) {
      if (!btn) return;
      var scrollEl = btn.closest('.ft-colors--scroll');
      if (scrollEl) {
        scrollActiveColorInScroll(scrollEl, 'smooth', btn);
        updateColorScrollPeek();
        return;
      }
      if (btn.scrollIntoView) {
        btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        updateColorScrollPeek();
      }
    }

    function updateColorScrollPeek() {
      qsa('.ft-colors-scroll-wrap').forEach(function (wrap) {
        var scroll = wrap.querySelector('.ft-colors--scroll');
        if (!scroll) return;

        if (!window.matchMedia('(max-width: 760px)').matches) {
          wrap.classList.remove('ft-colors-scroll-wrap--overflow', 'ft-colors-scroll-wrap--end');
          return;
        }

        var overflows = scroll.scrollWidth > scroll.clientWidth + 2;
        var atEnd = scroll.scrollLeft + scroll.clientWidth >= scroll.scrollWidth - 2;
        wrap.classList.toggle('ft-colors-scroll-wrap--overflow', overflows);
        wrap.classList.toggle('ft-colors-scroll-wrap--end', !overflows || atEnd);
      });
    }

    function initColorScrollPeek() {
      if (window.__ftColorScrollPeekBound) return;
      window.__ftColorScrollPeekBound = true;

      document.addEventListener(
        'scroll',
        function (event) {
          if (
            event.target &&
            event.target.classList &&
            event.target.classList.contains('ft-colors--scroll')
          ) {
            updateColorScrollPeek();
          }
        },
        { passive: true, capture: true }
      );
      window.addEventListener('resize', updateColorScrollPeek);
      updateColorScrollPeek();
    }

    function activateColorButton(btn) {
      qsa('.ft-color-btn').forEach(function (el) {
        var on = el === btn;
        el.classList.toggle('active', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      scrollColorIntoView(btn);
    }

    function setColor(btn) {
      if (!btn) return;
      selectedStyle = btn.getAttribute('data-style') || selectedStyle;
      styleColorMemory[selectedStyle] = btn.getAttribute('data-color');
      var variant = findVariantForSelection(
        selectedStyle,
        btn.getAttribute('data-color')
      );
      applyResolvedVariant(variant, btn);
    }

    function setStyle(styleBtn) {
      if (!styleBtn) return;
      var style = styleBtn.getAttribute('data-style');
      if (!style || style === selectedStyle) return;

      qsa('.ft-style-btn').forEach(function (el) {
        var on = el === styleBtn;
        el.classList.toggle('active', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      selectedStyle = style;

      var rememberedColor = styleColorMemory[style];
      var targetBtn = null;
      if (rememberedColor) {
        qsa('[data-ft-colors-scroll] .ft-color-btn').some(function (btn) {
          if (
            btn.getAttribute('data-style') === style &&
            btn.getAttribute('data-color') === rememberedColor
          ) {
            targetBtn = btn;
            return true;
          }
          return false;
        });
      }
      if (!targetBtn) {
        qsa('[data-ft-colors-scroll] .ft-color-btn').some(function (btn) {
          if (btn.getAttribute('data-style') === style) {
            targetBtn = btn;
            return true;
          }
          return false;
        });
      }
      if (targetBtn) setColor(targetBtn);
    }

    function openSheet() {
      if (qs('#ftOverlay')) qs('#ftOverlay').classList.add('show');
      if (qs('#ftSheet')) qs('#ftSheet').classList.add('show');
    }

    function closeSheet() {
      if (qs('#ftOverlay')) qs('#ftOverlay').classList.remove('show');
      if (qs('#ftSheet')) qs('#ftSheet').classList.remove('show');
    }

    // Scroll the buy box to just under the sticky logo bar instead of centering
    // it — centering tucks the top of the card behind the fixed navbar.
    function scrollBuyBoxIntoView() {
      var box = qs('#ftBuyBox');
      if (!box) return;
      var nav = document.querySelector('.ft-nav');
      var navH = nav ? nav.offsetHeight : 0;
      var currentY = window.pageYOffset || document.documentElement.scrollTop || 0;
      var target = box.getBoundingClientRect().top + currentY - navH - 12;
      window.scrollTo({ top: target < 0 ? 0 : target, behavior: 'smooth' });
    }

    function shakePacks() {
      qsa('[data-pack-group]').forEach(function (group) {
        group.classList.remove('ft-shake');
        group.offsetHeight;
        group.classList.add('ft-shake');
      });
      scrollBuyBoxIntoView();
    }

    function buyNow(btn) {
      if (!selectedPack) {
        openSheet();
        shakePacks();
        return;
      }

      var qty = packQtyMap[selectedPack] || packQtyMap['1'] || 1;
      var fromFinal = btn && btn.closest('.ft-final');
      var fromSticky = btn && btn.closest('#ftSticky');
      var fromSheet = btn && btn.closest('#ftSheet');
      var needsOptionsSheet = !!(fromFinal || fromSticky || fromSheet);

      if (qty > 1 || needsOptionsSheet) {
        openColorSheet(qty);
        return;
      }

      checkoutWithVariants([selectedVariantId], btn);
    }

    function goToBuy() {
      scrollBuyBoxIntoView();
    }

    qsa('.ft-pack-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setPack(
          btn.getAttribute('data-pack'),
          btn.getAttribute('data-price'),
          btn.getAttribute('data-label')
        );
      });
    });
    qsa('[data-buy-now]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        buyNow(btn);
      });
    });
    qsa('[data-sticky-buy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!selectedPack) openSheet();
        else buyNow(btn);
      });
    });
    qsa('[data-scroll-buy]').forEach(function (btn) {
      btn.addEventListener('click', goToBuy);
    });
    qsa('.ft-color-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setColor(btn);
      });
    });
    qsa('.ft-style-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setStyle(btn);
      });
    });

    var activeColorBtn = qs('[data-ft-colors-scroll] .ft-color-btn.active');
    if (!activeColorBtn) activeColorBtn = qs('.ft-color-btn.active');
    if (activeColorBtn) {
      styleColorMemory[selectedStyle] = activeColorBtn.getAttribute('data-color');
      updateColorLabel(activeColorBtn);
      dispatchGalleryColorChange(
        getGalleryColorFromButton(activeColorBtn) ||
          getGalleryColorForVariant(getSelectedVariant())
      );
      updateMainPriceDisplay(getSelectedVariant());
      updatePackPrices(getSelectedVariant() ? getSelectedVariant().price : productData.unitPriceCents);
      scrollColorIntoView(activeColorBtn);
    }
    updateBuyTitle((getSelectedVariant() && getSelectedVariant().style) || selectedStyle);
    initColorScrollPeek();

    var defaultPack = String(productData.defaultPack || '2');
    var defaultPackBtn = qs('.ft-pack-btn[data-pack="' + defaultPack + '"]');
    if (defaultPackBtn) {
      setPack(
        defaultPackBtn.getAttribute('data-pack'),
        defaultPackBtn.getAttribute('data-price'),
        defaultPackBtn.getAttribute('data-label')
      );
    }

    var sticky = qs('#ftSticky');
    var buyBox = qs('#ftBuyBox');
    if (sticky && buyBox && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            sticky.classList.toggle('show', !entry.isIntersecting);
          });
        },
        { threshold: 0 }
      );
      obs.observe(buyBox);
    }

    initDeliveryEstimate(productData);

    qsa('.ft-faq-q').forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.parentNode;
        qsa('.ft-faq-item').forEach(function (other) {
          if (other !== item) {
            other.classList.remove('open');
            other.querySelector('.ft-faq-q span:last-child').textContent = '+';
          }
        });
        var open = item.classList.toggle('open');
        q.querySelector('span:last-child').textContent = open ? '−' : '+';
      });
    });

    if (qs('#ftOverlay')) qs('#ftOverlay').addEventListener('click', closeSheet);
    if (qs('#ftClose')) qs('#ftClose').addEventListener('click', closeSheet);

    if (qs('#ftColorOverlay')) {
      qs('#ftColorOverlay').addEventListener('click', closeColorSheet);
    }
    if (qs('#ftColorClose')) {
      qs('#ftColorClose').addEventListener('click', closeColorSheet);
    }
    if (qs('[data-ft-color-cancel]')) {
      qs('[data-ft-color-cancel]').addEventListener('click', closeColorSheet);
    }
    if (qs('[data-ft-color-checkout]')) {
      qs('[data-ft-color-checkout]').addEventListener('click', function () {
        confirmColorCheckout(qs('[data-ft-color-checkout]'));
      });
    }
  }

  function init() {
    initFiveToeSocksBuyGalleryLayout();
    initFiveToeSocksStickyNav();
    initFiveToeSocksPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
